// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1rUv8","paramInput":"JobSimulator_paramInput__3klXa","input":"JobSimulator_input__-1gKs"};